import React, { useState, useRef, useEffect } from "react";
import "./Fading.css";

import { LazyLoadImage } from "react-lazy-load-image-component";

export default function MediaGrid(props) {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  const mediaCount = props.mediaGrid.split("\r\n\r\n").length;

  // Helper function to generate a random number between two values
  function getRandomDelay(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  // Generate an array of random delays based on the imageCount
  const delays = Array.from({ length: mediaCount }, () => getRandomDelay(100, 7000));

  // Generate an array to set opacity
  const [opacityLevels, setOpacityLevels] = useState(new Array(mediaCount).fill(0));

  const [animationCompleted, setAnimationCompleted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !animationCompleted) {
                setVisible(true); // If this is not used anywhere else, you can remove this line
                
                delays.forEach((delay, index) => {
                    setTimeout(() => {
                        const interval = setInterval(() => {
                            setOpacityLevels((prevLevels) => {
                                const newLevels = [...prevLevels];
                                if (newLevels[index] < 1) {
                                    newLevels[index] += 0.05;
                                    return newLevels;
                                } else {
                                    clearInterval(interval); // Stop the interval once opacity reaches 1
                                    if(index === mediaCount - 1) { 
                                        setAnimationCompleted(true);
                                    }
                                    return prevLevels;
                                }
                            });
                        }, 50); // This determines the speed of the fade-in for each image. Lower to make faster.
                    }, delay);
                });
            }
        });
        },
        {
            threshold: [0.3]
          }
        );

    observer.observe(domRef.current);

    // Cleanup
    return () => {
        observer.unobserve(domRef.current);
    };
}, [animationCompleted]);

  return (
      <div
          style={{
              position: "relative",
              display: "grid",                 // Use 'grid' instead of 'flex'
              gridTemplateColumns: props.isMobile? "repeat(3, 1fr)":"repeat(5, 1fr)",  // 5 columns
              gap: "1.5vh 1vw",                    // Use 'gap' property to space items instead of padding on each item
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "black",
              padding: "10vh 10vw 0vh 10vw",
          }}
          ref={domRef}  // Move ref to the container

      >
          {props.mediaGrid.split("\r\n\r\n").map((s, i) => (
              <div key={i}>
                  <div ref={domRef}>
                      {s.startsWith(" VIDEO:") ? (
                          <video
                              style={{ opacity: opacityLevels[i] }}
                              width="100%"
                              src={s.replace(" VIDEO:", "")}
                              muted={true}
                              loop={true}
                              autoPlay={true}
                              playsInline={true}>
                          </video>
                      ) : (
                          <LazyLoadImage
                              style={{ opacity: opacityLevels[i] }}
                              src={s}
                              width="100%"
                              alt="description of media"
                          />
                      )}
                  </div>
              </div>
          ))}
      </div>
  );
}
